module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///wAzmSH5BAAAAAAALAAAAAAMAAwAAAIWjI+pCt37QkRxngpYlpu67i0XKJZmAQA7"